import React, { useContext, useEffect, useState, useRef } from 'react'
import { PageTitle } from '../../../layout/core'
import ReactModal from 'react-modal'
import IBotDeleteModal from './IBotDeleteModal'
import axios from 'axios'
import { toast } from 'react-toastify'
import TextTemplate from './template/TextTemplate'
import Intent from './template/intent'
import UserContext from '../../../context/UserContext'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { useNavigate } from 'react-router-dom'

const IBotListings = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [deleteBotId, useDeleteBotId] = useState<any>('')
  const [selectedBot, setSelectedBot] = useState<any>('')
  const [stateConversation, setStateConversation] = useState<any>([])
  const [userInput, setUserInput] = useState<any>()
  const [allBots, setAllBots] = useState<any>([])
  const { currentUser } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [selectedIBotName, setSelectedIdBotName] = useState<any>('')
  const [conversationPageLoading, setConversationPageLoading] = useState<boolean>(false)
  const [leftSideLoading, setLeftSideLoading] = useState<boolean>(false)
  const [fileUploadLoading, setFileUploadLoading] = useState<boolean>(false)
  const conversationMessagesRef = useRef<HTMLDivElement>(null)
  const [fileName, setFileName] = useState<any>(null)
  const [filePayload, setFilePayload] = useState<any>({
    bg_id: currentUser?.id,
    bot_id: '',
    pdf_files: ''
  })

  const textareaRef = useRef(null)

  const SaveOpenModal = (botid: any) => {
    useDeleteBotId(botid)
    setIsModalOpen(true)
  }

  const SaveAfterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const SaveCloseModal = () => {
    setIsModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-60%',
      transform: 'translate(-40%, -60%)'
    }
  }

  useEffect(() => {
    fetchAllBots()
  }, [])

  useEffect(() => {
    scrollToBottom()
  }, [stateConversation])

  const fetchAllBots = async () => {
    setIsLoading(true)
    try {
      const params = {
        bg_id: currentUser.id
      }

      const response = await axios.get(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/all_bots?bg_id=${currentUser.id}`,
        { params }
      )

      setAllBots(response?.data?.bots)
      setIsLoading(false)

      // if (response && response.data.bots) {
      //   const botsData = response.data.bots
      //   // Convert response data to array of objects
      //   const botsArray = Object.keys(botsData).map((botId) =>
      //   ({
      //     bot_id: botId,
      //     bot_name: botsData.bot_name
      //   })
      //   )

      //   setAllBots(botsArray)
      //   setIsLoading(false)
      // }
    } catch (error) {
      // Handle errors
      console.error('Error making the GET request:', error)
      setIsLoading(false)
    }
  }

  const fetchData = async (botId: any) => {
    if (!!botId && botId.length > 0) {
      setConversationPageLoading(true)

      try {
        const params = {
          bot_id: botId
        }

        const response = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/history?bot_id=${botId}`
          // { params }
        )

        if (response) {
          setFileName(response?.data?.data)
          setStateConversation(response?.data?.data?.messages)
          setUserInput('')
          setConversationPageLoading(false)
        }
      } catch (error) {
        // Handle errors
        console.error('Error making the GET request:', error)
        setConversationPageLoading(false)
      }
    }
  }

  const sendMessage = async () => {
    if (!userInput) {
      // Handle the case when userInput is empty or undefined
      return
    }

    // eslint-disable-next-line no-control-regex
    // NOSONAR
    const sanitizedUserInput = userInput.replace(/[\u0000-\u001F\u007F-\u009F]/g, '')

    const userData = { content: { message: sanitizedUserInput } }

    setStateConversation((prev: any) => [...prev, userData])

    setLeftSideLoading(true)
    try {
      const formData = new FormData()
      formData.append('question', `{"content":{"message": "${sanitizedUserInput}"}}`)
      formData.append('bot_id', selectedBot)
      setUserInput('')
      const response = await axios.post(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/message`,
        formData,
        {}
      )

      if (response && response.data) {
        setStateConversation((prev: any) => [...prev, response.data])
      }

      // fetchData(selectedBot)
    } catch (error) {
      console.error('Error making the POST request:', error)
      setLeftSideLoading(false)
    } finally {
      setLeftSideLoading(false)
    }
  }

  const SelectedBot = (botId: any, botName: any) => {
    setSelectedBot(botId)
    setSelectedIdBotName(botName)
    fetchData(botId)
  }

  const scrollToBottom = () => {
    if (conversationMessagesRef.current) {
      conversationMessagesRef.current.scrollTop = conversationMessagesRef.current.scrollHeight
    }
  }
  const navigate = useNavigate()
  const handleNavigate = () => {
    navigate('/automation/process-automation/ask-pdf')
  }

  const handleFileUpload = async (e: any) => {
    setFileUploadLoading(true)
    const file = e.target.files[0]

    try {
      const formData = new FormData()
      formData.append('pdf_files', file)
      formData.append('bg_id', filePayload.bg_id)
      formData.append('bot_id', selectedBot)

      const response = await axios.post(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/file_upload`,
        formData,
        {}
      )

      setFilePayload({
        ...filePayload,
        pdf_files: response.data.pdf_files
      })

      toast.success(response?.data?.status)
      await fetchData(selectedBot)
    } catch (error: any) {
      const errorMessage = error?.response?.data?.status

      // Check if the error message indicates an unreadable document
      if (errorMessage === 'Unreadable document') {
        setTimeout(() => {
          alert(`Your uploaded PDF file is not readable because of any of the following reasons:
          
          • PDF contains scanned images
          • PDF is password protected
          • PDF is corrupted
          • PDF has encoding issues
          • PDF features are not supported
          `)
        }, 500)
      } else {
        toast.error(errorMessage)
      }
    } finally {
      setFileUploadLoading(false)
      e.target.value = ''
    }
  }

  useEffect(() => {
    setFilePayload({
      bg_id: currentUser?.id,
      bot_id: '',
      pdf_files: ''
    })
  }, [selectedBot])

  const chatHandler = (e: any) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault()
      if (!userInput.trim()) {
        // Check if userInput is empty or contains only whitespace
        return
      }
      sendMessage()
    } else {
      setUserInput(e.target.value)
      if (textareaRef.current) {
        const textarea = textareaRef.current as HTMLTextAreaElement
        textarea.style.height = 'auto'
        textarea.style.height = `${textarea.scrollHeight}px`
      }
    }
  }

  return (
    <>
      <div>
        <PageTitle breadcrumbs={[]}>All IBots</PageTitle>
      </div>

      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-column flex-lg-row-auto w-100 w-350px mx-lg-0'>
          <div className='card card-flush'>
            <div
              className='card-header pt-7 justify-content-start fs-4 fw-bolder text-gray-900'
              id='kt_chat_contacts_header'
            >
              <div className='card-title align-items-start flex-row'>
                <span className='mt-1 text-hover-primary' onClick={handleNavigate}>
                  <i className='bi bi-arrow-left' style={{ fontSize: '1.75rem' }}></i>
                </span>
                <div className='d-flex flex-column ms-7'>
                  <span className='card-label fw-bolder fs-3 mb-1'>iBot listings</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>List of iBots to pick from</span>
                </div>
              </div>
            </div>
            <div className='card-body pt-5' id='kt_chat_contacts_body'>
              <div className='scroll-y mh-700px'>
                {isLoading ? (
                  <div>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <>
                    {allBots.length === 0 ? (
                      <div className='text-center'>No iBot Available</div>
                    ) : (
                      <>
                        {allBots?.map((item: any) => (
                          <div
                            key={item?.bot_id} // Corrected key to item.bot_id
                            className='d-flex flex-stack justify-content-between py-4'
                          >
                            <div
                              className='d-flex align-items-center'
                              onClick={() => SelectedBot(item.bot_id, item.bot_name)}
                            >
                              <div className={`symbol symbol-45px symbol-circle`}>
                                {/* <span className={`symbol-label bg-green red fs-6 fw-bolder`}>
                                  A
                                </span> */}
                              </div>
                              <div className='ms-5'>
                                <div
                                  role='button'
                                  className={`fs-5 fw-bolder text-gray-900 text-hover-primary mb-2`}
                                >
                                  {item.bot_name}
                                </div>
                              </div>
                            </div>
                            <div>
                              <p
                                className='link-danger hoverable'
                                role='button'
                                onClick={() => SaveOpenModal(item.bot_id)}
                              >
                                <i className='bi bi-trash link-danger'></i>
                              </p>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedIBotName && (
          <div className='flex-lg-row-auto ms-lg-7 ms-xl-10 w-350px'>
            <div className='card w-350px align-items-center' id='uploadpdf_panel'>
              <div
                className='card-header w-250px pt-7 justify-content-center fs-4 fw-bolder text-gray-900'
                id='uploadpdf_header'
              >
                <div className='fs-4 text-xl-left fw-bolder mb-5'>
                  Upload your PDF File({selectedIBotName})
                </div>
                <div className='scroll-y mh-700px scroll-y me-n5 pe-5 mh-700px w-325px'>
                  <div className='d-block justify-content-center align-items-center my-10'>
                    <h6 className='text-center'>Train your AI Model</h6>
                    {/* <input className = "form-control form-control-sm" type="file" name="" id="" /> */}
                    <label
                      id='pic1'
                      style={{
                        border: '1px dotted darkslategrey',
                        textAlign: 'center',
                        color: 'darkslategrey',
                        borderRadius: '4px',
                        margin: 'auto',
                        width: '120px',
                        padding: '10px',
                        display: 'block',
                        backgroundColor: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      {filePayload.pdf_files !== '' ? (
                        <div>{fileName?.filenames}</div>
                      ) : (
                        <div>
                          <label htmlFor='fileToUpload'>
                            {fileUploadLoading ? 'Uploading...' : 'Click Here to Upload'}
                          </label>
                          <input
                            onChange={handleFileUpload}
                            type='file'
                            name='fileToUpload'
                            id='fileToUpload'
                            size={1}
                            style={{
                              display: 'none'
                            }}
                          />
                        </div>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
          <div className='card' id='kt_chat_messenger'>
            <div className='card-header' id='kt_chat_messenger_header'>
              <div className='card-title'>
                <div className='symbol-group symbol-hover'></div>
                <div className='d-flex justify-content-center flex-column me-3'>
                  <div className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                    {selectedIBotName}
                  </div>
                </div>
              </div>
              <div className='card-toolbar'>
                <div className='me-20 badge bg-secondary text-black fw-bold p-4'>
                  {/* IBot Assistant */}
                </div>
              </div>
            </div>
            <div className='card-body' id='kt_chat_messenger_body'>
              <div className='scroll-y me-n5 pe-5 mh-550px' ref={conversationMessagesRef}>
                {conversationPageLoading ? (
                  <div>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <>
                    {stateConversation && stateConversation.length > 0 ? (
                      stateConversation?.map((message: any, index: any) => (
                        <div
                          key={index}
                          className={`d-flex mb-10 ${
                            message.content.side === 'lhs'
                              ? 'justify-content-start'
                              : 'justify-content-end'
                          }`}
                        >
                          {/* Bot's information */}
                          <div className='d-flex flex-column align-items align-items-end'>
                            <TextTemplate
                              message={message?.content?.message}
                              side={message?.content?.side}
                              fileName={fileName?.filenames}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className='d-flex mb-10 justify-content-center'>
                        {/* Bot's information */}
                        <div className='d-flex flex-column align-items align-items-center'>
                          No Data Available for this iBot
                        </div>
                      </div>
                    )}
                    {leftSideLoading && (
                      <div className={`d-flex mb-10 justify-content-start`}>
                        {/* Bot's information */}
                        <div className='d-flex flex-column align-items align-items-end'>
                          <span className='dots-cont'>
                            <span className='dot dot-1 botgo-font-color'></span>
                            <span className='dot dot-2 botgo-font-color'></span>
                            <span className='dot dot-3 botgo-font-color'></span>
                          </span>
                          {/* <>Typing</> */}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className='card-footer pt-4' id='kt_chat_messenger_footer'>
                {fileName?.filenames && (
                  <textarea
                    className='form-control form-control-flush mb-3'
                    style={{
                      border: '1px solid  #cccccc',
                      borderRadius: '10px',
                      minHeight: '40px',
                      maxHeight: '100px'
                    }}
                    rows={1}
                    placeholder='Type a message'
                    name='chatInput'
                    value={userInput}
                    ref={textareaRef}
                    onChange={chatHandler}
                    onKeyDown={chatHandler}
                    // onChange={(e) => setUserInput(e.target.value)}
                  ></textarea>
                )}

                <div className='d-flex flex-stack'>
                  <div></div>
                  {/* <div className='d-flex align-items-center me-2'>
                    <button
                      className='btn btn-sm btn-icon btn-active-light-primary me-1'
                      type='button'
                      title='Coming soon'
                    >
                      <i className='bi bi-paperclip fs-3'></i>
                    </button>
                    <button
                      className='btn btn-sm btn-icon btn-active-light-primary me-1'
                      type='button'
                      title='Coming soon'
                    >
                      <i className='bi bi-upload fs-3'></i>
                    </button>
                  </div> */}
                  {!!selectedIBotName && filePayload.pdf_files !== '' && (
                    <button className='btn btn-primary' type='submit' onClick={sendMessage}>
                      Send
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReactModal
          isOpen={isModalOpen}
          onAfterOpen={SaveAfterOpenModal}
          onRequestClose={SaveCloseModal}
          style={customModalStyles}
          contentLabel='Edit User'
        >
          <IBotDeleteModal
            SaveCloseModal={SaveCloseModal}
            deleteBotId={deleteBotId}
            fetchAllBots={fetchAllBots}
          />
        </ReactModal>
      </div>
    </>
  )
}

export default IBotListings
